import { Box, Checkbox, Link, Paper, Typography } from '@ace-clublabs/shared-component-library';

import { ReactNode } from 'react';

export interface IPartnerPromoCardProps {
  selected: boolean;
  label: string | TrustedHTML;
  image: string;
  linkUrl: string;
  onClick: (e: any) => void;
  lastInGroup: boolean;
  firstInGroup: boolean;
  groupTitle?: string;
  partnerName: string;
  children: JSX.Element;
}

export const PartnerPromoCard = ({
  selected,
  label,
  image,
  linkUrl,
  onClick,
  lastInGroup,
  firstInGroup,
  groupTitle,
  partnerName,
  children,
}: IPartnerPromoCardProps) => {
  const labelElement = selected ? (
    <strong style={{ fontWeight: 500 }} dangerouslySetInnerHTML={{ __html: label }} />
  ) : (
    <span dangerouslySetInnerHTML={{ __html: label }} />
  );

  const borderRadius =
    firstInGroup && lastInGroup
      ? '0.5rem'
      : firstInGroup && !lastInGroup
      ? '0.5rem 0.5rem 0 0'
      : !firstInGroup && lastInGroup
      ? '0 0 0.5rem 0.5rem'
      : '0';

  return (
    <Box
      className="partner-promo-card-container"
      sx={{
        marginTop: firstInGroup ? '1rem' : '0',
      }}
    >
      <Paper sx={{ padding: '1rem', borderRadius: borderRadius }}>
        {firstInGroup && (
          <Typography className="partner-promo-card-group-title" color="primary">
            {groupTitle}
          </Typography>
        )}
        <Checkbox
          data-testid={`checkbox-${partnerName}`}
          defaultChecked={selected}
          variant="text"
          value=""
          label={<Typography color="primary">{labelElement}</Typography>}
          name="partner-promo-card-checkbox"
          onClick={onClick}
          fullWidth
        />
        {children}
        <Link className="partner-link" target="_blank" href={linkUrl}>
          <Typography component="span" variant={'b2Regular'} color="#0156A3">
            Learn more
          </Typography>
        </Link>
        <Box display={'flex'} justifyContent={'end'}>
          <img
            style={{
              width: `128px`,
              height: `40px`,
              aspectRatio: `16/5`,
              borderRadius: '8px',
            }}
            src={image}
          />
        </Box>
      </Paper>
    </Box>
  );
};
